import styled from 'styled-components';

const Views = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export default Views;
